import { atom } from "recoil";
import { FoodItem } from "../services/foodApiService";
import { ScannedData } from "../types/foodManagement";

type GlucoseCurvePoint = {
  time_min: number;
  glucose_mg_dl: number;
  new_meal_rise: number;
  prev_meal_remaining: number;
  total_rise: number;
  phase: string;
};

type GlucoseCurve = {
  points: GlucoseCurvePoint[];
  is_cumulative: boolean;
  starting_glucose: number;
  peak_glucose: number;
  peak_time_min: number;
  recovery_time_min: number;
};

type GlucoseSpikeData = {
  spike_category: string;
  spike_band: string;
  spike_range: { low: number; high: number };
  spike_level: number;
  color: string;
  emoji: string;
  title: string;
  description: string;
  ui_message: string;
  predicted_spike_mg_dl: number;
  this_meal_spike_mg_dl: number;
  is_cumulative: boolean;
  previous_meal_remaining_mg_dl: number;
  previous_meal_elapsed_min: number | null;
  cumulative_note: string | null;
  confidence: string;
  confidence_margin_mg_dl: number;
  time_to_peak_min: number;
  recovery_time_min: number;
  recommendations: string[];
  // START value fields
  baseline_glucose?: number;
  // PEAK value fields
  predicted_peak_glucose?: number;
  predicted_peak_glucose_this_meal_only?: number;
  // Full glucose curve for chart rendering
  glucose_curve?: GlucoseCurve;
};

export const scannedDataAtom = atom<ScannedData | null>({
  key: "scannedData",
  default: null,
});

export const foodItemsFromBackendAtom = atom<FoodItem[]>({
  key: "foodItemsFromBackend",
  default: [],
});

export const uploadedImageAtom = atom<string | null>({
  key: "uploadedImage",
  default: null,
});

export const documentIdAtom = atom<string | null>({
  key: "documentId",
  default: localStorage.getItem("glucera_document_id"),
});

export const ghiReasonsAtom = atom<string[] | null>({
  key: "ghiReasons",
  default: null,
});

export const ghiScoreAtom = atom<number | null>({
  key: "ghiScore",
  default: null,
});

export const ghiLabelAtom = atom<string | null>({
  key: "ghiLabel",
  default: null,
});

export const bbsScoreAtom = atom<number | null>({
  key: "bbsScore",
  default: null,
});

export const bbsLabelAtom = atom<string | null>({
  key: "bbsLabel",
  default: null,
});

export const otherDetailsAtom = atom<{
  phyto_color_count?: number;
  alcohol_g?: number;
  caffeine_mg?: number;
  has_ultra_processed_food?: boolean;
} | null>({
  key: "otherDetails",
  default: null,
});

export const glucoseSpikeAtom = atom<GlucoseSpikeData | null>({
  key: "glucoseSpikeData",
  default: null,
});
